import React, {type PropsWithChildren, type CSSProperties, type FC} from 'react'
import clsx from 'clsx'
import type {StatusModalType} from '../types'
import styles from './BottomSheet.scss'

export type BottomSheetProps = PropsWithChildren & {
  onClose?: () => void;
  style?: CSSProperties
  classes?: {
    bottomsheet?: string;
    handle?: string;
  }
  status: StatusModalType
};

export const BottomSheet: FC<BottomSheetProps> = (props) => {
  const {children, classes, onClose, status, style} = props;
  const isOpen = status === 'open'
  const isClose = status === 'close'

  return (
    <div className={clsx(
        styles.modalsContainerBackground,
        isOpen && styles.openBottomsheetBacground,
        isClose && styles.closeBottomsheetBackground,
      )}
    >
      <div
        className={clsx(
          styles.bottomsheet,
          classes?.bottomsheet,
          isOpen && styles.openBottomsheet,
          isClose && styles.closeBottomsheet,
        )}
        style={style}
      >
        {onClose && (
          <span className={clsx(styles.handle, classes?.handle)} onClick={onClose} draggable={true} />
        )}
        {children}
      </div>
    </div>
  )
}
